module.exports = __webpack_public_path__ + "assets/img/dh4.f3827ee1.jpg";